<script setup>
import { computed } from 'vue';

const props = defineProps({
    erro: {
        type: String,
        default: null
    },
    modelValue: {
        type: Number,
    },
    titulo: {
        type: String,
        default: 'Descrição'
    },
    placeholder: {
        type: String,
        default: ''
    },
    numeroComVirgula: {
        type: Boolean,
        default: true
    },
    smallTitleObrigatorio: {
        type: Boolean,
        default: true
    }
});

const emit = defineEmits(['update:modelValue', 'change']);

const texto = computed({
    get: () => props.modelValue,
    set: (value) => {
        emit('update:modelValue', value);
        emit('change', value);
    }
});
</script>

<template>
    <div class="field mb-2 col-12">
        <SmallTitle :titulo="titulo" :obrigatorio="smallTitleObrigatorio" />
        <InputNumber placeholder="0,00" class="text-sm" locale="pt-BR" inputClass="text-sm"
            :minFractionDigits="props.numeroComVirgula ? 2 : 0" v-model.trim="texto" :class="{ 'p-invalid': props.erro }" />
        <SmallError v-if="props.erro" :error="props.erro" />
    </div>
</template>